import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import Notification from "../notification/Notification";
import { TextField } from "@material-ui/core";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import CurrenciesByServiceRelationshipsSelect from "../serviceReletionships/CurrenciesByServiceRelationshipsSelect";
import { isValidHttpsUrl } from "../../../utils/checkValidHttpsUrl";
import { useTranslation } from "react-i18next";

import { StyledInvoiceWrapper } from "../invoiceDialog/styledInvoice";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const CreateBlockchainUrlButton = ({ notification, setNotification }) => {
  const { t } = useTranslation("blockchainUrlPage");

  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const defaultData = {
    "currency": null,
    "paymentSystem": null,
    "value": null,
    "settings": null
  };

  const [submitData, setSubmitData] = useState(defaultData);

  const handleSubmit = (event) => {
    event.preventDefault();

    setDisabled(true);

    let checkFields = false;

    for (let [key, value] of Object.entries(defaultData)) {
      if (submitData[key] === null) {
        checkFields = true;
        break;
      }
    }

    if (checkFields) {
      setNotification({ ...notification, visible: true, type: "error", message: t("createForm.errors.checkFieldsMessage") });
      setDisabled(false);

      return;
    }

    if (!isValidHttpsUrl(submitData.value)) {
      setNotification({ ...notification, visible: true, type: "error", message: t("createForm.errors.isValidHttpsUrlMessage") });
      setDisabled(false);

      return;
    }

    axios.post("/api/currency-settings", submitData, userAuthenticationConfig(false)).then(response => {
      if (response.status === 201) {
        handleClose();
        setNotification({ ...notification, visible: true, type: "success", message: t("createForm.successMessage") });
      }
    }).catch(error => {
      handleClose();
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSubmitData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledInvoiceWrapper className="blockchain-url-head__create">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("createForm.create")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("createForm.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              <CurrenciesByServiceRelationshipsSelect
                submitData={submitData}
                setSubmitData={setSubmitData}
              />
              <TextField
                id="value"
                label={t("createForm.link")}
                value={submitData.value}
                onChange={(data) => setSubmitData({ ...submitData, "value": data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("createForm.cancel")}
              </DefaultButton>
              <DefaultButton
                color="success"
                onClick={handleSubmit}
                disabled={disabled}
              >
                {t("createForm.create")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledInvoiceWrapper>
    </>
  );
};

export default CreateBlockchainUrlButton;